export const VENMO_PAYMENT_STATUS = {
  SUCCEEDED: 'succeeded',
  FAILED: 'failed',
} as const;

export const VENMO_ERRORS = {
  INITIALIZATION_FAILED: 'Failed to initialize Venmo',
  TOKENIZATION_FAILED: 'Failed to tokenize Venmo payment',
  INVALID_ADDRESS: 'Invalid address provided',
} as const;

export const VENMO_ERROR_MESSAGE_KEYS: Record<string, string> = {
  VENMO_APP_CANCELED: '',
  VENMO_CANCELED: '',
  VENMO_CUSTOMER_CANCELED: '',
  VENMO_DESKTOP_CANCELED: '',
  VENMO_MOBILE_POLLING_TOKENIZATION_CANCELED: '',
  VENMO_MOBILE_POLLING_TOKENIZATION_EXPIRED: 'venmoErrors.sessionTimeout',
  VENMO_MOBILE_POLLING_TOKENIZATION_TIMEOUT: 'venmoErrors.sessionTimeout',
  VENMO_NETWORK_ERROR: 'venmoErrors.connection',
  VENMO_MOBILE_POLLING_TOKENIZATION_NETWORK_ERROR: 'venmoErrors.connection',
  VENMO_APP_FAILED: 'venmoErrors.unknown',
  VENMO_DESKTOP_UNKNOWN_ERROR: 'venmoErrors.unknown',
  VENMO_MOBILE_POLLING_TOKENIZATION_NO_CONTEXT_ID: 'venmoErrors.unknown',
  VENMO_MOBILE_POLLING_TOKENIZATION_FAILED: 'venmoErrors.unknown',
  VENMO_TOKENIZATION_FAILED: 'venmoErrors.unknown',
  VENMO_TOKENIZATION_CANCELED_BY_MERCHANT: '',
  VENMO_TOKENIZATION_REQUEST_ACTIVE: '',
  VENMO_TOKENIZATION_REQUEST_NOT_ACTIVE: '',
  VENMO_ECD_DISABLED: '',
} as const;
